
import { useAuthTabSwitcher as useBaseAuthTabSwitcher } from '@/core/auth/useAuthTabSwitcher';
import { AUTH_TAB_SWITCH_EVENT } from '@/pages/AuthPage';

type AuthTab = 'signin' | 'signup' | 'reset';

/**
 * Application-specific hook that uses the generic auth tab switcher
 * with the application's specific event name
 */
export const useAuthTabSwitcher = () => {
  return useBaseAuthTabSwitcher(AUTH_TAB_SWITCH_EVENT);
};
